import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { customValidation, validations } from "../../../commonFunctions/CommonFunctions";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import WSSelectField from "../../../Components/Select/WSSelect";
import config from "../../../Config/clientConfig.json";

export const BusinessSource: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
      <Grid container  spacing={2}>
        <Grid item xs={12} sm={3}>
          <Typography>Market Segment</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSSelectField
                rules={{ required: true }}
                {...register("marketsegment")}
                id="marketsegment"
                control={control}
                defaultValue={"0"}
                label=""
                name="marketsegment"
                options={config.marketConfig.staticOptionData}
                />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Business Source</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSSelectField
                rules={{ required: true }}
                {...register("businesssource")}
                id="businesssource"
                control={control}
                defaultValue={"0"}
                label=""
                name="businesssource"
                options={config.businesssourceConfig.staticOptionData}
                />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Description</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSTextAreaField
                  label={""}
                  id={"description"}
                  name={"description"}
                  control={control}
                  rules={{ required: false }}
                  rows={3}
                />    
        </Grid>
        
      </Grid>
  );
});
